const state= {
    Loadings:{
        list: false,
        detail: false,
    },
    Item: null,
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    Item : (state) => state.Item,
};

const actions = {
    async uploadAttachment({commit,state},params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          formData.append('attachments[0]', params.attachment);
          formData.append('id', params.id);
          formData.append('type', params.type || '');
          formData.append('file_title', params.file_title || '');
          if(params.hasOwnProperty("reference_id")){
            formData.append('reference_id', params.reference_id);
          }
          global.axios(`/api/eme-safety-app/attachments/type`, {
              method: "POST",
              headers: {
                Accept: "application/json",
              },
              data : formData
          })
          .then(response => {
                commit( 'setLoadings', {key:"detail",val:false});
                resolve( response );
          })
          .catch(error => reject( error ));
        });
      },
    async createAttachment({commit,state},params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          formData.append('photos[0]', params.attachment);
          global.axios(`/api/eme-safety-app/attachments`, {
              method: "POST",
              headers: {
                Accept: "application/json",
              },
              data : formData
          })
          .then(response => {
                commit( 'setLoadings', {key:"detail",val:false});
                resolve( response );
          })
          .catch(error => reject( error ));
        });
      },
      async createAttachmentWithType({commit,state},params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          formData.append('id', params.id);
          formData.append('type', params.type);
          for(let i = 0; i < params.attachments.length; i++){
            formData.append(`attachments[${i}]`, params.attachments[i]);
          }
          global.axios(`/api/eme-safety-app/attachments/type`, {
              method: "POST",
              headers: {
                Accept: "application/json",
              },
              data : formData
          })
          .then(response => {
                commit( 'setLoadings', {key:"detail",val:false});
                resolve( response );
          })
          .catch(error => reject( error ));
        });
      },
      async removeAttachments({commit},params){
        return new Promise (( resolve, reject ) => {
          global.axios(`/api/eme-safety-app/attachments`, {
              method: "DELETE",
              headers: {
                Accept: "application/json",
              },
              data : params
          })
          .then(response => {
             resolve( response );
          })
          .catch(error => reject( error ));
        });
      },
      async updateAttachments({commit,state},params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          formData.append('file_title', params.file_title || '');
          if(params.hasOwnProperty('reference_id')){
            formData.append('reference_id', params.reference_id);
          }
          if(params.attachment)
            formData.append('photo', params.attachment);
            global.axios(`api/eme-safety-app/attachments/${params.id}`, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                },
                data : formData
            })
            .then(response => {
              commit( 'setLoadings', {key:"detail",val:false})
              resolve( response );
            })
            .catch(error => reject( error ));
          });
      },
      async getAttachmentsItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/eme-safety-app/attachments`, { params: params })
              .then(response => {
                resolve(response.data)
              })
              .catch(error => reject(error));
        });
    },
};

const mutations = {
    setListItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit )
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setItem (state, data) {
        state.Item = data;
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
